import { FaTools } from 'react-icons/fa';
import { ScreenState } from './ScreenState';
import { useLanguage } from '../../../Hooks/Contexts/Translate/useLanguageContext';

/*
    🔥 MANTENIMIENTO

    ⚠️ VA A PANTALLA COMPLETA POR DEFECTO

    Es el único estado donde eso es correcto: si el sistema está caído,
    dejar el header y el sidebar navegables promete algo que no se
    puede cumplir. Cada clic terminaría en otro error.

    ⚠️ LA HORA ESTIMADA SE MUESTRA SOLO SI EXISTE

    "Volvemos pronto" sin hora es ruido. Con hora, el usuario decide si
    espera o vuelve más tarde, que es la única decisión que le queda.
*/

export const ScreenMaintenance = ({
    title = null,
    description = null,
    estimatedTime = null,        // '14:30' | 'aproximadamente 20 minutos'
    isFullScreen = true,
    actions = null,
}) => {

    const { useDataLanguage } = useLanguage();

    const TEXT = useDataLanguage.translations?.TEMPLATES?.screen ?? {};

    return (
        <ScreenState
            icon={<FaTools />}
            tone="warn"
            size="lg"
            title={title ?? TEXT.maintenanceTitle}
            description={description ?? TEXT.maintenanceText}
            isFullScreen={isFullScreen}
            actions={actions}
        >
            {
                estimatedTime && (
                    <p className="LStudio__app_screen__eta">
                        {TEXT.maintenanceEta}: <strong>{estimatedTime}</strong>
                    </p>
                )
            }
        </ScreenState>
    );
};
